import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const AlgoliaPage = lazy(() =>
  import('../../pages/admin/algolia/AlgoliaPage').then((m) => ({
    default: m.AlgoliaPage,
  })),
);

export const Route = createFileRoute('/admin/algolia')({
  component: () => (
    <Suspense
      fallback={
        <Spinner
          style={{
            position: 'absolute',
            top: '25%',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />
      }
    >
      <AlgoliaPage />
    </Suspense>
  ),
});
